import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    userDeactivationDialog: {
        open: false,
        user: undefined,
    },
    roleEdit: {
        isCrossdockClaimChecked: false,
        isLocationClaimChecked: false,
        isRoleEditFormDirty: false,
    },
};
const identitySlice = createSlice({
    name: 'identity',
    initialState,
    reducers: {
        openUserDeactivationDialog: (state, action) => {
            state.userDeactivationDialog.open = true;
            state.userDeactivationDialog.user = {
                email: action.payload.userEmail,
                fullName: action.payload.userFullName,
                userId: action.payload.userId,
                avatar: action.payload.userAvatar,
            };
        },
        closeUserDeactivationDialog: (state) => {
            state.userDeactivationDialog.open = false;
        },
        setCrossdockClaimChecked: (state, action) => {
            state.roleEdit.isCrossdockClaimChecked = action.payload.checked;
            state.roleEdit.isRoleEditFormDirty = Boolean(action.payload.shouldDirty);
        },
        setLocationClaimChecked: (state, action) => {
            state.roleEdit.isLocationClaimChecked = action.payload.checked;
            state.roleEdit.isRoleEditFormDirty = Boolean(action.payload.shouldDirty);
        },
        emptyCustomClaimsData: (state) => {
            state.roleEdit = initialState.roleEdit;
        },
    },
});
export const { actions: identityActions, reducer: identityStateReducer } = identitySlice;
